<template>
  <form name="modal" :scrollable="true" width="300px" height="auto">
    <b-loading v-model="isLoading"></b-loading>
    <div class="modal-card" style="width: auto">
      <header class="modal-card-head">
        <p class="modal-card-title">注文内容</p>
        <button type="button" class="delete" @click="$emit('close')" />
      </header>

      <section class="modal-card-body">
        <p class="subtitle">合計 {{ doronAmount }} ドロン</p>
        <p class="subtitle">ご請求額 {{ doronAmount * 1 }} 円</p>
        <b-select
          expanded
          v-model="paymentMethod"
          placeholder="カードを選択してください"
        >
          <option
            v-for="(paymentMethod, index) in paymentMethods"
            :key="index"
            :value="paymentMethod"
          >
            {{ paymentMethod.brand }} ••••{{ paymentMethod.last4 }}
          </option>
        </b-select>
      </section>

      <footer class="modal-card-foot">
        <b-button label="Close" @click="$emit('close')" />
        <b-button label="Submit" @click="onClickSubmit" type="is-primary" />
      </footer>
    </div>
  </form>
</template>

<script>
export default {
  name: 'DoronPurchaseFormModal',
  computed: {
    paymentMethods() {
      return this.$store.getters['payment/paymentMethods'];
    }
  },
  props: { doronAmount: Number, doronToYenRate: Number },
  async created() {
    await this.$store.dispatch('payment/loadCustomer', {
      userId: this.$store.state.auth.uid,
      email: this.$store.state.auth.email
    });
    this.isLoading = false;
  },
  data() {
    return {
      paymentMethod: null,
      isLoading: true
    };
  },
  methods: {
    async onClickSubmit() {
      this.isLoading = true;
      await this.$store.dispatch('doron/purchaseDoron', {
        userId: this.$store.state.auth.uid,
        cardId: this.paymentMethod.id,
        amount: this.doronAmount,
        freeAmount: 0
      });
      this.isLoading = false;
      this.$emit('close');
    }
  }
};
</script>

<style lang="scss" scoped>
.modal-card-body {
  height: fit-content;
  width: 400px;
  padding: 20px 25px;
  .subtitle {
    font-weight: normal;
  }
  @include touch {
    width: 100%;
  }
  .payment-select {
    width: 100%;
  }
}
</style>
